import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const getLoginState = () =>
  sessionStorage.getItem('logInState') || localStorage.getItem('logInState');

export const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirect';

export const savePostLoginRedirect = (pathname, search = '') => {
  const redirect = `${pathname || ''}${search || ''}`;
  sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, redirect);
  return `/?redirect=${encodeURIComponent(redirect)}`;
};

export const consumePostLoginRedirect = (search) => {
  const fromQuery = new URLSearchParams(search).get('redirect');
  const fromSession = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  const redirect = fromQuery || fromSession;
  if (redirect) {
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  }
  return redirect;
};

const ProtectedRoute = ({ element: Component }) => {
  const location = useLocation();
  const loginState = getLoginState();

  if (!loginState) {
    return <Navigate to={savePostLoginRedirect(location.pathname, location.search)} replace />;
  }

  return <Component />;
};

export default ProtectedRoute;
